export const WEEKDAYS = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday'];

export const NON_DELIVERY_FIELDS = [
  { key: 'courierCcNonDeliveryDays', label: 'courier cold-chain' },
  { key: 'courierNonDeliveryDays', label: 'courier non-cold-chain' },
  { key: 'upsCcNonDeliveryDays', label: 'UPS cold-chain' },
  { key: 'upsNonDeliveryDays', label: 'UPS non-cold-chain' },
];
